import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation UploadFileAttachment($id: ID!, $input: UploadFileAttachmentInput!) {
    uploadFileAttachment(id: $id, input: $input) {
      writeUrl
      readUrl
      maxBytes
      acl
    }
  }
`);
